// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__2YZlA","titleBtn":"styles_titleBtn__L42Bv","tableRow":"styles_tableRow__3RiV6","sorted":"styles_sorted__1ww_T","restore":"styles_restore__2qjYQ"};